import update from 'immutability-helper';
import {
  CREATE_ALERT,
  DISMISS_ALERT,
  DISMISS_LAST_ALERT,
} from '../constants/ActionTypes';

const initialState = {
  alerts: [],
};

export default function alert(state = initialState, action = {}) {
  let nextAlerts;

  switch (action.type) {
    case CREATE_ALERT:
      // change alert id from array length to timestamp
      // to prevent exception 'duplicate component key'
      nextAlerts = update(state.alerts, { $push: [{
        id: new Date().getTime(),
        type: action.alertType,
        text: action.text,
        timeout: action.timeout,
      }] });
      return update(state, { alerts: { $set: nextAlerts } });

    case DISMISS_ALERT:
      nextAlerts = state.alerts.filter(a => a.id !== action.alertId);
      return update(state, { alerts: { $set: nextAlerts } });

    case DISMISS_LAST_ALERT:
      nextAlerts = state.alerts;
      nextAlerts.shift();
      return update(state, { alerts: { $set: nextAlerts } });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/alert.js